import QRCode from "qrcode.react";

const ModMedBarcode = ({ payload }: { payload: string }) => {
  return (
    <div className="Barcode">
      <p className="Barcode__label"></p>
      <div className="Barcode__qr">
        <QRCode
          value={`${payload}`}
          size={60}
          bgColor={"#ffffff"}
          fgColor={"var(--black)"}
          level={"L"}
          includeMargin={false}
          renderAs={"svg"}
        />
      </div>
    </div>
  );
};

export default ModMedBarcode;
